var _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFgLight3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.34 143.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGISTICS"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.48 32.56 96.46 60.26 96.47 115.67 48.48 143.37 0.5 115.67 0.5 60.26 48.48 32.56",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,115.79,48.42,88.22m.18-.87V32.79m0,55.18,47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.77,118.32a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,21.77,118.32Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,117.6a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,23,117.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.28,116.88a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,24.28,116.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.53,116.15a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,25.53,116.15Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.78,115.43c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,26.78,115.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,114.72a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,28,114.72Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.29,114c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,29.29,114Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.55,113.27a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,30.55,113.27Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,112.55a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,31.8,112.55Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05,111.82a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,33.05,111.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,111.1c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,34.3,111.1Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,110.38a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,35.56,110.38Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81,109.65a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,36.81,109.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.82,
    cy: 109.07,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.31,108.21c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,39.31,108.21Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.57,107.48a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,40.57,107.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.82,106.76a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,41.82,106.76Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.07,106c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,43.07,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,108.93a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,35.56,108.93Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81,108.21a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,36.81,108.21Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06,107.48a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,38.06,107.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.31,106.76c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,39.31,106.76Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.57,106a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27.51.51,0,0,1,.48,0C40.7,106.11,40.44,106,40.57,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,108.21c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,34.3,108.21Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,107.48a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,35.56,107.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81,106.76a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,36.81,106.76Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06,106a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,38.06,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05,107.48a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,33.05,107.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,106.76c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,34.3,106.76Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.32,
    cy: 106.18,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.57,
    cy: 105.45,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,106.76a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,31.8,106.76Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.81,
    cy: 106.18,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,105.31c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,34.3,105.31Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.56,104.59a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28.51.51,0,0,1,.48,0Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.53,106c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,30.53,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,105.31a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,31.79,105.31Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,104.58a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,33,104.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.29,103.86c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,34.29,103.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.53,104.58c.14.08.14.2,0,.28a.49.49,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,30.53,104.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,103.86a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,31.79,103.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,103.14a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27.51.51,0,0,1,.48,0C33.17,103.21,32.91,103.06,33,103.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.53,103.14c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,30.53,103.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.79,102.41a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,31.79,102.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.62,
    cy: 128.57,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12,127.71a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,48.12,127.71Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,128.43a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.36,128.43Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.61,127.71a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.61,127.71Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,127a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,46.86,127Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,127.71c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,43.1,127.71Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,127a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,44.36,127Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.61,126.26a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,45.61,126.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.85,127a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,41.85,127Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,126.26c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,43.1,126.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,125.54a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,44.36,125.54Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.61,
    cy: 125.67,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,124.81c.14.08.14.2,0,.28a.49.49,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,43.1,124.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.84,124.08a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0C41.23,124.28,41.71,124,41.84,124.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.31,125.53c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,29.31,125.53Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57,124.81a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,30.57,124.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.82,124.08a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,31.82,124.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.07,123.36a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,33.07,123.36Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.32,122.64c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,34.32,122.64Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.58,121.91a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,35.58,121.91Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.83,121.19a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,36.83,121.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.81,125.53a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,26.81,125.53Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.06,124.81a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,28.06,124.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.31,124.08c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,29.31,124.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.57,123.36a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,30.57,123.36Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.82,122.64a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,31.82,122.64Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.83,
    cy: 122.05,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.32,121.19c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,34.32,121.19Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.58,120.47a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,35.58,120.47Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3,125.53a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,24.3,125.53Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.32,
    cy: 124.94,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.81,124.08a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,26.81,124.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.05,124.81a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,23.05,124.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3,124.08a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,24.3,124.08Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.79,124.07a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,21.79,124.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,123.35a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,23,123.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.53,123.35c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,20.53,123.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.79,122.63a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,21.79,122.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.28,122.63a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,19.28,122.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.53,121.9c.14.08.14.21,0,.28a.51.51,0,0,1-.48,0c-.13-.07-.13-.2,0-.28A.57.57,0,0,1,20.53,121.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.28,121.18a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,19.28,121.18Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.31,119.74a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27C21.65,120.09,21.17,119.81,21.31,119.74Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,119a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,23,119Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.29,118.29c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,24.29,118.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.54,117.57c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,25.54,117.57Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8,116.84a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,26.8,116.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.05,116.12a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,28.05,116.12Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,127.27a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62,126.27c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,50.62,126.27Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,125.55a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,51.88,125.55Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.13,124.82a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,53.13,124.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,124.1c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,54.38,124.1Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.64,123.38a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,55.64,123.38Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,122.65a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,56.89,122.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,121.93a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,58.14,121.93Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,121.21c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,59.39,121.21Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.65,120.48a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,60.65,120.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.64,126.27a.51.51,0,0,1,.48,0,.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0A.15.15,0,0,1,47.64,126.27Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,125.55a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.37,125.55Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62,124.82c.14.08.14.2,0,.28a.49.49,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,50.62,124.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,124.1a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,51.88,124.1Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.13,123.38a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,53.13,123.38Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,122.65c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,54.38,122.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.64,121.93a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,55.64,121.93Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.65,
    cy: 121.34,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,120.48a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,58.14,120.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,119.76c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,59.39,119.76Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.39,125.55a.49.49,0,0,1,.47,0c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0C46.25,125.75,46.25,125.62,46.39,125.55Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12,124.82a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,48.12,124.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,124.1a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,49.37,124.1Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62,123.38c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,50.62,123.38Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,122.65a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,51.88,122.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.65,121.93a.51.51,0,0,1,.48,0,.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,121.21c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,54.38,121.21Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.64,120.48a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,55.64,120.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,119.76a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,56.89,119.76Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.13,124.82a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0A.15.15,0,0,1,45.13,124.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,124.38a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28C44,124,44.49,124.3,44.36,124.38Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,122.65a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,44.35,122.65Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,121.92c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,45.6,121.92Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,121.2c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.14-.08-.14-.21,0-.28A.51.51,0,0,1,46.86,121.2Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,120.48a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,48.11,120.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.12,
    cy: 119.89,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,119c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,50.61,119Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,118.31a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,51.87,118.31Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,117.58a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,53.12,117.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,121.92a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,43.1,121.92Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,121.2c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,44.35,121.2Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,120.48c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.6,120.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,119.75a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,46.86,119.75Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,119a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,48.11,119Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,118.31a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.36,118.31Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,117.58c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,50.61,117.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,116.86a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,51.87,116.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,116.14a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,53.12,116.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.37,121.2a.49.49,0,0,1,.47,0c.14.07.14.2,0,.28a.55.55,0,0,1-.47,0C41.23,121.4,41.23,121.27,41.37,121.2Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,120.48a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,43.1,120.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.87,119.75a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28C44,119.68,43.74,119.83,43.87,119.75Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,119c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0C45,119.23,45.47,119,45.6,119Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,118.31a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0C46.24,118.51,46.72,118.23,46.86,118.31Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.13,116.41a.14.14,0,0,1,0-.27.51.51,0,0,1,.48,0C50.75,116.21,50.27,116.49,50.13,116.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,115.41a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,49.36,115.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,114.69c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,50.61,114.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.61,120.48a.49.49,0,0,1,.47,0c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0C37.47,120.68,37.47,120.55,37.61,120.48Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.34,119.75a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,39.34,119.75Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.59,119a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,40.59,119Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.84,118.31c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,41.84,118.31Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,117.58a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,43.1,117.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,116.86a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.35,116.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,116.14c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.6,116.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,115.41a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,46.86,115.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,114.69a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,48.11,114.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,114a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.36,114Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,119.75a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0A.15.15,0,0,1,36.35,119.75Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.09,119a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,38.09,119Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.34,118.31a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,39.34,118.31Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.59,117.58a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,40.59,117.58Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.84,116.86c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,41.84,116.86Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1,116.14a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,43.1,116.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,115.41a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,44.35,115.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,114.69c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,45.6,114.69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,114a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0c-.14-.07-.14-.2,0-.27A.51.51,0,0,1,46.86,114Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,113.24a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,48.11,113.24Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,111.8a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,48.11,111.8Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,111.07a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,49.36,111.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,110.35c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,50.61,110.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,109.63a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,51.87,109.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,108.9a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,53.12,108.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,108.18a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,54.37,108.18Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,107.46c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,55.62,107.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.62,113.52a.15.15,0,0,1,0-.28.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28A.51.51,0,0,1,42.62,113.52Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.35,112.52a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.35,112.52Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,111.8c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.6,111.8Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,111.07a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,46.86,111.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.11,110.35a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,48.11,110.35Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,109.63a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.36,109.63Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,108.9c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,50.61,108.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.87,108.18a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,51.87,108.18Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.12,107.46a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,53.12,107.46Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,106.73a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,54.37,106.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,112.51c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,41.83,112.51Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,111.79c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,43.09,111.79Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,111.07a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,44.34,111.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,110.34a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,45.59,110.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.61,
    cy: 109.76,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,108.9a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,48.1,108.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35,108.17a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,49.35,108.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,107.45c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,50.6,107.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.62,
    cy: 106.86,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,106a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,53.11,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,111.79c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,40.58,111.79Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,111.07c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,41.83,111.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.85,
    cy: 110.48,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,109.62a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,44.34,109.62Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,108.9a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,45.59,108.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.61,
    cy: 108.31,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,107.45a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,48.1,107.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35,106.73a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,49.35,106.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,106c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,50.6,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86,105.28a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,51.86,105.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,111.07a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,39.33,111.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,110.34a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,40.58,110.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,109.62c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,41.83,109.62Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,108.9a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,43.09,108.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,108.17a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,44.34,108.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,107.45a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,45.59,107.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.84,106.73c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,46.84,106.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,106a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,48.1,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35,105.28a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,49.35,105.28Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.83,115.41a.49.49,0,0,1,.47,0c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0C28.69,115.61,28.69,115.48,28.83,115.41Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.56,114.68a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,30.56,114.68Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.81,114a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,31.81,114Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.06,113.24c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,33.06,113.24Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.08,
    cy: 112.65,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.57,111.79c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,35.57,111.79Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.82,111.07c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,36.82,111.07Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.08,110.34a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,38.08,110.34Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,109.62a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,39.33,109.62Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.58,108.9a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,40.58,108.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,108.17c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,41.83,108.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,107.45a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,43.09,107.45Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34,106.73a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,44.34,106.73Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,106a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,45.59,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,129.05a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,70.73,129.05Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,128.33a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,72,128.33Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23,127.61c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,73.23,127.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,126.88a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,74.49,126.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22,129.05c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,68.22,129.05Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48,128.33a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,69.48,128.33Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,127.61a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,70.73,127.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,126.88a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,72,126.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23,126.16c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,73.23,126.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,125.44a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,74.49,125.44Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,129.05a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,65.72,129.05Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,128.33a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,67,128.33Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22,127.61c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,68.22,127.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.48,126.88a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,69.48,126.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,126.16a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,70.73,126.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,125.44a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,72,125.44Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23,124.71c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,73.23,124.71Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,128.33c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.49.49,0,0,1,64.46,128.33Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,127.61a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,65.72,127.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,126.88a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,67,126.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.22,126.16c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,68.22,126.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,127.61a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,63.21,127.61Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.46,126.88c.14.08.14.2,0,.28a.49.49,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,64.46,126.88Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,126.16a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,65.72,126.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,126.16a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,63.21,126.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.23,
    cy: 125.58,
    rx: 0.34,
    ry: 0.2,
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,124.71a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,63.2,124.71Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,124a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,62,124Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,123.26a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,63.2,123.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,123.26a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.51.51,0,0,1,60.7,123.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,122.54a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,62,122.54Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,121.81a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,63.2,121.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.44,122.54c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,59.44,122.54Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,121.81a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0c-.14-.08-.14-.2,0-.28A.57.57,0,0,1,60.7,121.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,121.09a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,62,121.09Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.41,106.74a.51.51,0,0,1,.48,0,.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0C56.28,106.94,56.27,106.82,56.41,106.74Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,106a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,58.14,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,105.29c.14.08.14.2,0,.28a.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,59.39,105.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.15,106a.51.51,0,0,1,.48,0c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0C55,106.22,55,106.09,55.15,106Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.89,105.29a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,56.89,105.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,104.57a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.51.51,0,0,1,58.14,104.57Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.39,103.85c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,59.39,103.85Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.89,105.29a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0A.14.14,0,0,1,53.89,105.29Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,104.56c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,55.62,104.56Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,103.84c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,56.88,103.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.13,103.12a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,58.13,103.12Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.64,104.56a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0A.15.15,0,0,1,52.64,104.56Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,103.84c.13.07.13.2,0,.28a.57.57,0,0,1-.48,0c-.13-.08-.13-.21,0-.28A.51.51,0,0,1,54.37,103.84Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,103.12c.14.07.14.2,0,.27a.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,55.62,103.12Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,102.39a.15.15,0,0,1,0,.28.51.51,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,56.88,102.39Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.68,120.27a7,7,0,0,0-6.49,0l-7,4a6,6,0,0,1-5.32,0,1.24,1.24,0,0,1,0-2.39l8.06-4.65a2.37,2.37,0,0,0,0-4.43l-.17-.11a7.07,7.07,0,0,0-6.5,0l-15.57,9a6,6,0,0,1-5.32,0l-2.83-1.63a1.56,1.56,0,0,1-.93-1.2c0-.42.34-.85.93-1.19l24.42-14a3.74,3.74,0,0,0,3.06-.13,1,1,0,0,0,0-1.92,3.62,3.62,0,0,0-3.33,0c-.57.33-.79.78-.65,1.21L20,116.68a2.38,2.38,0,0,0,0,4.43l2.83,1.63a7.08,7.08,0,0,0,6.49,0l15.58-9a6,6,0,0,1,5.32,0l.17.11c.59.34.93.77.93,1.19a1.56,1.56,0,0,1-.93,1.2l-8.05,4.65a2.37,2.37,0,0,0,0,4.43,7.08,7.08,0,0,0,6.49,0l7-4a6,6,0,0,1,5.31,0l3.16,2,.56-1.57Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE",
    d: "M61.82,119.29a7,7,0,0,0-6.5,0l-7,4a6,6,0,0,1-5.32,0,1.56,1.56,0,0,1-.93-1.2c0-.42.34-.85.93-1.19l8.06-4.66a2.37,2.37,0,0,0,0-4.42l-.18-.11a7.08,7.08,0,0,0-6.49,0l-15.58,9a6,6,0,0,1-5.31,0l-2.83-1.63c-.59-.35-.93-.78-.93-1.2s.34-.85.93-1.19l24.67-14.17a3.74,3.74,0,0,0,2.67-.26,1,1,0,0,0,0-1.93,3.69,3.69,0,0,0-3.33,0c-.7.41-.86,1-.5,1.49L20.1,115.7a2.37,2.37,0,0,0,0,4.43l2.83,1.63a7.08,7.08,0,0,0,6.49,0l15.58-9a6,6,0,0,1,5.31,0l.18.11c.59.34.93.77.93,1.19s-.34.85-.93,1.19l-8.06,4.66a2.38,2.38,0,0,0,0,4.43,7.1,7.1,0,0,0,6.5,0l7-4a6,6,0,0,1,5.31,0l3.16,2,1.31-.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-2",
    "data-name": "ACTIVE",
    d: "M67.7,97.28c-3.35,1.54-6.35,6.22-6.64,10.53a6.3,6.3,0,0,0,.91,4.08L66.79,121l2.31,1.13c.21-.47,3.59-16.54,3.74-17h0c.36-1.13,2.83-1.84,2.85-2.94C75.76,98.19,71,95.78,67.7,97.28Zm-.42,10.31c-1.32.66-2.33-.15-2.25-1.79a5.13,5.13,0,0,1,2.48-4c1.28-.61,2.26.17,2.21,1.75A5.13,5.13,0,0,1,67.28,107.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.49,123.36a2.48,2.48,0,0,0-2.25,0c-.62.35-.62.93,0,1.29a2.48,2.48,0,0,0,2.25,0C70.11,124.29,70.11,123.71,69.49,123.36Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.93,121.7a7.74,7.74,0,0,0-7.13,0,2.46,2.46,0,0,0,0,4.61,7.82,7.82,0,0,0,7.13,0,2.46,2.46,0,0,0,0-4.61Zm-.42,3.87a7,7,0,0,1-6.29,0,1.64,1.64,0,0,1,0-3.14,7,7,0,0,1,6.29,0A2,2,0,0,1,72.68,124,1.93,1.93,0,0,1,71.51,125.57Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.49,122.5a2.54,2.54,0,0,0-2.25,0,.69.69,0,0,0,0,1.3,2.48,2.48,0,0,0,2.25,0A.69.69,0,0,0,69.49,122.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.93,120.85a7.74,7.74,0,0,0-7.13,0,2.46,2.46,0,0,0,0,4.61,7.82,7.82,0,0,0,7.13,0,2.46,2.46,0,0,0,0-4.61Zm-.42,3.87a7,7,0,0,1-6.29,0,1.64,1.64,0,0,1,0-3.14,7,7,0,0,1,6.29,0,1.64,1.64,0,0,1,0,3.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.23,122.51l-2.63-1.28,0-.07L61.74,112a6.47,6.47,0,0,1-.93-4.21c.28-4.34,3.33-9.16,6.78-10.75h0a6.18,6.18,0,0,1,5.8.59A5.35,5.35,0,0,1,76,102.21c0,.71-.78,1.24-1.52,1.74s-1.2.82-1.35,1.28c-.06.19-.69,3.12-1.35,6.23-1.32,6.15-2.27,10.53-2.39,10.81ZM67,120.85l2,1c.31-1.25,1.44-6.51,2.29-10.46.81-3.76,1.31-6.08,1.37-6.28.2-.62.88-1.09,1.55-1.54s1.28-.88,1.29-1.32a4.84,4.84,0,0,0-2.33-4.14,5.64,5.64,0,0,0-5.3-.56h0c-3.31,1.52-6.22,6.15-6.49,10.32a6,6,0,0,0,.86,3.92Zm-.58-12.78a1.46,1.46,0,0,1-.82-.24,2.21,2.21,0,0,1-.81-2,5.35,5.35,0,0,1,2.63-4.26,1.77,1.77,0,0,1,1.77,0,2.17,2.17,0,0,1,.81,2,5.45,5.45,0,0,1-2.59,4.31h0A2.23,2.23,0,0,1,66.4,108.07Zm1.94-6.26a1.73,1.73,0,0,0-.72.18,4.87,4.87,0,0,0-2.34,3.82,1.73,1.73,0,0,0,.58,1.6,1.29,1.29,0,0,0,1.3,0,4.86,4.86,0,0,0,2.31-3.86,1.7,1.7,0,0,0-.58-1.53A.94.94,0,0,0,68.34,101.81Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,102.9c.07-4-2.46-6-5.73-4.49s-6.35,6.22-6.63,10.53a6.24,6.24,0,0,0,.9,4.08l4.82,9.15,5.51-14.46c.21-.47.39-.95.55-1.43h0A11.59,11.59,0,0,0,75.74,102.9Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.23,122.51l-.31-.14-4.86-9.23a6.53,6.53,0,0,1-.94-4.21c.29-4.34,3.33-9.16,6.79-10.75a4.21,4.21,0,0,1,4.14,0c1.29.85,2,2.51,2,4.69h0a12.11,12.11,0,0,1-.6,3.46c-.16.49-.35,1-.56,1.46ZM72.1,98.16a4.74,4.74,0,0,0-2,.48c-3.31,1.52-6.22,6.15-6.49,10.32a6,6,0,0,0,.86,3.92l4.58,8.67,5.3-13.93a13.73,13.73,0,0,0,.54-1.42,11.42,11.42,0,0,0,.58-3.3c0-2-.59-3.53-1.72-4.26A3,3,0,0,0,72.1,98.16Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3,111.86l-2.46-1.67c-.34-.23-.32-.92.06-1.54h0c.37-.61,1-.92,1.3-.68l1.24.84,2.28-4.64c.32-.64.9-1,1.3-.9h0c.39.14.45.78.13,1.42l-3.42,6.91C69.62,111.82,69.41,111.94,69.3,111.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.39 87.08 44.13 79.42 30.88 87.08 30.88 87.08 30.88 102.38 44.13 110.03 44.13 94.77 57.39 87.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.88 102.33 44.13 109.99 44.13 94.72 30.88 87.03 30.88 87.03 30.88 102.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,86.92l-13.53-7.8L30.65,86.9l0,0h0v.31h0v15.3l13.26,7.66h0l.26.15.27-.15h0l13.12-7.58.14-.08V87.23h0ZM44.13,79.73l6.23,3.6L37.64,90.67l-6.23-3.59Zm-.26,29.85-12.73-7.35V87.54l12.73,7.34Zm5.66-18.27-5.4,3.11L37.9,90.83l12.73-7.35,6.23,3.6Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.87,94.75l-2.46-1.42a.74.74,0,0,0-.78,0,1,1,0,0,0-.4.86,2.15,2.15,0,0,0,.91,1.72l2.46,1.41a.86.86,0,0,0,.45.13.76.76,0,0,0,.33-.08,1,1,0,0,0,.4-.86A2.12,2.12,0,0,0,38.87,94.75Zm.24,2.12c-.07,0-.18,0-.24-.05L36.41,95.4a1.58,1.58,0,0,1-.65-1.25c0-.24.08-.37.14-.4a.23.23,0,0,1,.24,0l.17.1a2,2,0,0,0,.84,1.42l2.1,1.21A.48.48,0,0,1,39.11,96.87Z",
    style: {
      fill: "#111"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.48,32.56.5,60.26,48.48,88l48-27.71Zm48,27.7L48.48,88v55.4l48-27.7ZM48.48,88,.5,60.26v55.41l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "PURCHASE"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.85 0.29 152.84 27.99 152.84 83.4 104.86 111.1 56.87 83.4 56.87 27.99 104.85 0.29",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,83.52,105,55.7m0,0L104.85.29M105,55.7l47.55,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "PURCHASE-2",
    "data-name": "PURCHASE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7",
    "data-name": 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.76,
    cy: 92.55,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.24,91.7c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.27A.49.49,0,0,1,92.24,91.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,91c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,93.48,91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,91.7c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,89.76,91.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,91c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,91,91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 90.4,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.53,91c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,88.53,91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.53,
    cy: 90.4,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,89.55a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,91,89.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.29,90.27c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,87.29,90.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.53,89.55a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,88.53,89.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.53,
    cy: 88.97,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,89.55a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,86.05,89.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.05,
    cy: 88.97,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.53,88.12a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,88.53,88.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,88.83c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,84.8,88.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,88.12c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,86,88.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.28,87.4c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.55.55,0,0,1,87.28,87.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57,88.12c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,83.57,88.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,87.4c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,84.8,87.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,86.69c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,86,86.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,87.4c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.55.55,0,0,1,82.33,87.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57,86.69c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,83.57,86.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,86a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,84.8,86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,86.69c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,81.09,86.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.09,
    cy: 86.11,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.33,
    cy: 85.39,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.62,
    cy: 86.11,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,85.26a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,81.09,85.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,84.54a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,82.33,84.54Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,85.26a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,78.62,85.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,84.54a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,79.85,84.54Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.85,
    cy: 83.97,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,84.54a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,77.38,84.54Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,83.83a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,78.62,83.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,83.11a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,79.85,83.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.14,83.83a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,76.14,83.83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.38,83.11a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,77.38,83.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,82.4c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,78.62,82.4Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.89,83.11c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,74.89,83.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.13,82.39a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,76.13,82.39Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37,81.68a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,77.37,81.68Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.89,81.68a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,74.89,81.68Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.13,81a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,92.3c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,93.52,92.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,91.58c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,94.76,91.58Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,90.28c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,94.72,90.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,89.56c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,96,89.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,88.85c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,97.19,88.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,88.13a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,98.43,88.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,87.42a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,99.67,87.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,86.7a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,100.9,86.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14,86a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,102.14,86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,85.27a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,103.38,85.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,84.56c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,104.62,84.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,83.85c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,105.85,83.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.85,
    cy: 83.27,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,82.42c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.14-.08-.14-.2,0-.27A.49.49,0,0,1,108.33,82.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,81.7a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,109.57,81.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,81a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,110.8,81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.8,
    cy: 80.41,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.28,79.56a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,113.28,79.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.52,78.84a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,114.52,78.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,89.56a.55.55,0,0,1,.47,0c.13.08.13.2,0,.27a.52.52,0,0,1-.47,0C92.88,89.76,92.87,89.64,93,89.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,88.85c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,94.72,88.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,88.13c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,96,88.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,87.42a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,97.19,87.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,86.7a.15.15,0,0,1,0,.28A.55.55,0,0,1,98,87a.15.15,0,0,1,0-.28A.55.55,0,0,1,98.43,86.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,86a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,99.67,86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.67,
    cy: 85.41,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14,84.56c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,102.14,84.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,83.85c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,103.38,83.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,83.13c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,104.62,83.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,82.42c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,105.85,82.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,81.7a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,107.09,81.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,81a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,108.33,81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,80.27a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,109.57,80.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,79.56a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,110.8,79.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,78.84a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,112,78.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.04,
    cy: 78.27,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.77,88.85a.49.49,0,0,1,.47,0c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0A.14.14,0,0,1,91.77,88.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,88.13a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,93.48,88.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,87.42a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,94.72,87.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,86.7c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,96,86.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.96,
    cy: 86.13,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,85.27a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,98.43,85.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,84.56c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,99.67,84.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,83.85c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,100.9,83.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.91,
    cy: 83.27,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,82.42c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,103.38,82.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,81.7a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,104.62,81.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,81a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,105.85,81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.85,
    cy: 80.41,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,79.56a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,108.33,79.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,78.84a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,109.57,78.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,78.13c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,110.8,78.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,77.42c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112,77.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.53,88.13a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0A.15.15,0,0,1,90.53,88.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.24,87.42a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,92.24,87.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,86.7a.15.15,0,0,1,0,.28A.55.55,0,0,1,93,87a.15.15,0,0,1,0-.28A.55.55,0,0,1,93.48,86.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,86a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,94.72,86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,85.27c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,96,85.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,84.56c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,97.19,84.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,83.85c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,98.43,83.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,83.13c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,99.67,83.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,82.42c.14.07.14.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,100.9,82.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.91,
    cy: 81.84,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,81a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,103.38,81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,80.27a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,104.62,80.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,79.56a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,105.85,79.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,78.84a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,107.09,78.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,78.13c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.55.55,0,0,1,108.33,78.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,77.42c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,109.57,77.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,76.7c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,110.8,76.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.29,87.42a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0A.14.14,0,0,1,89.29,87.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,86.7A.15.15,0,0,1,91,87a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,91,86.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.01,
    cy: 86.13,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.24,
    cy: 85.41,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,84.56c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,94.72,84.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,83.85c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,96,83.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19,83.13c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,97.19,83.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,82.42c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,98.43,82.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.43,
    cy: 81.84,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9,81c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,100.9,81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.91,
    cy: 80.41,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.38,79.56a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,103.38,79.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,78.84a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,104.62,78.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,78.13c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,105.85,78.13Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09,77.42c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,107.09,77.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,76.7c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.55.55,0,0,1,108.33,76.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,76a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,109.57,76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,86.7a.51.51,0,0,1,.48,0c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0C87.91,86.89,87.91,86.77,88,86.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,86c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,89.76,86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,85.27c.14.07.14.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,91,85.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 84.69,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.23,
    cy: 83.97,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71,83.12a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,94.71,83.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,82.41a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,95.94,82.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.18,81.7c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,97.18,81.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,81c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.55.55,0,0,1,98.42,81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,80.27c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,99.66,80.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89,79.55a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,100.89,79.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13,78.84a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,102.13,78.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.13,
    cy: 78.26,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.61,77.41a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,104.61,77.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,76.69a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,105.84,76.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.08,76c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,107.08,76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.32,75.27c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,108.32,75.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,86a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0A.15.15,0,0,1,86.81,86Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,85.27c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,88.52,85.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,84.55a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,89.76,84.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.76,
    cy: 83.97,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.23,83.12a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,92.23,83.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47,82.41a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,93.47,82.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.47,
    cy: 81.83,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,81c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,95.94,81Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.18,80.27c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,97.18,80.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,79.55a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,98.42,79.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,78.84a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,99.66,78.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89,78.12a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,100.89,78.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13,77.41a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,102.13,77.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37,76.69a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0c-.14-.08-.14-.2,0-.28A.55.55,0,0,1,103.37,76.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.13,76a.51.51,0,0,1,.48,0c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,75.27c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.57,85.27a.49.49,0,0,1,.47,0,.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0A.14.14,0,0,1,85.57,85.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.28,84.55a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,87.28,84.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.52,83.84a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,88.52,83.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,83.12a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,89.76,83.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,82.41c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.76,81.7a.49.49,0,0,1,.47,0c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,81a.55.55,0,0,1,.47,0c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,80.27a.51.51,0,0,1,.48,0c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,79.55a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.33,84.55a.57.57,0,0,1,.48,0,.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0A.15.15,0,0,1,84.33,84.55Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.81,
    cy: 83.97,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.81,83.12a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,83.84a.49.49,0,0,1,.47,0,.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0C83,84,83,83.91,83.1,83.84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,83.4a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,82.68a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,98.75a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,122,98.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,98a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,123.25,98Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,97.32c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,124.48,97.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,96.61c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,125.72,96.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,95.89c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,127,95.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2,95.18c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,128.2,95.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43,94.46a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,129.43,94.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.3,
    cy: 98.89,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.54,
    cy: 98.17,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,97.32c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,122,97.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,96.61c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,123.25,96.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,95.89c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,124.48,95.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,95.18c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,125.72,95.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,94.46a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,127,94.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2,93.75a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,128.2,93.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43,93a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,129.43,93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,98a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,118.3,98Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,97.32c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,119.54,97.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77,96.61c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,120.77,96.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,95.89c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,122,95.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,95.18c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,123.25,95.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,94.46c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,124.48,94.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.49,
    cy: 93.88,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,93a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,127,93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2,92.32a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,128.2,92.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,97.32c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,117.06,97.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.06,
    cy: 96.74,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,95.89c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,119.54,95.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77,95.18c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,120.77,95.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,94.46a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,122,94.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,93.75a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,123.25,93.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,93c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,124.48,93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,92.32a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,125.72,92.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,91.6a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,127,91.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,96.61c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,115.82,96.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,95.89c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,117.06,95.89Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,95.18c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,118.3,95.18Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,94.46a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,119.54,94.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.54,
    cy: 93.88,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,93a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,122,93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.01,
    cy: 92.46,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48,91.6c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,124.48,91.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,90.89c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,95.88c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,114.57,95.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,95.17a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,115.81,95.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,94.46c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,117.05,94.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,93.74c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,118.29,93.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.29,
    cy: 93.16,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,92.31a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,120.76,92.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,91.6a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,122,91.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123,
    cy: 91.02,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.47,90.44a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,95.17a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,113.34,95.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,94.46c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,114.57,94.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,93.74c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,115.81,93.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,93c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,117.05,93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,92.31a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,118.29,92.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,91.6c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,119.52,91.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,90.88a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,120.76,90.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,90.17a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,122,90.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,94.46c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112.1,94.46Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,93.74c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,113.34,93.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,93c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,114.57,93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,92.31a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.81,92.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,91.6a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,117.05,91.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.05,
    cy: 91.02,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.29,
    cy: 90.31,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,89.45a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,120.76,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,93c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112.1,93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,92.31a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.34,92.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.34,
    cy: 91.73,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,90.88a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.81,90.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,90.17a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,117.05,90.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,89.45a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,118.29,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.29,
    cy: 88.88,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.53,
    cy: 88.16,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,87.31c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,122,87.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,86.6c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,123.24,86.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,91.6a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,112.1,91.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,90.88a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.34,90.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,90.17c.14.07.14.2,0,.27a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,114.57,90.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,89.45a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.81,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,88.74c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,117.05,88.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,88c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,118.29,88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,87.31c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,119.52,87.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,86.6c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,120.76,86.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.76,
    cy: 86.02,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,91.6a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,109.63,91.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,90.88a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,110.86,90.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,90.17a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,112.1,90.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,89.45a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.34,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,88.74c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,114.57,88.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.58,
    cy: 88.16,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,87.31c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,117.05,87.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,86.6c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,118.29,86.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,85.88c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,119.52,85.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.53,
    cy: 85.3,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,84.73a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.91,
    cy: 91.73,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,90.88a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,108.39,90.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,90.17a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,109.63,90.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,89.45a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,110.86,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,88.74c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,112.1,88.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,88c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,113.34,88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.34,
    cy: 87.45,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,86.6c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,115.81,86.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,85.88a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,117.05,85.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,85.17a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,118.29,85.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,84.45c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,119.52,84.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.68,
    cy: 91.02,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.15,90.17a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,107.15,90.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39,89.45a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,108.39,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,88.74c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,109.63,88.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,88c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,110.86,88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.86,
    cy: 87.45,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,86.6c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,113.34,86.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.34,
    cy: 86.02,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.81,85.17a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,115.81,85.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,84.45a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,117.05,84.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,83.74a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,118.29,83.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66,90.16c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,104.66,90.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,89.45c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,105.9,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,88.73a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,107.14,88.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,88a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,108.38,88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,87.3c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,109.61,87.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,86.59a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,110.85,86.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,85.87a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,112.09,85.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,85.16c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,113.33,85.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56,84.45c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,114.56,84.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.56,
    cy: 83.87,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.8,
    cy: 83.15,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,82.3a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28.57.57,0,0,1,.48,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,89.45c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,103.43,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66,88.73c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,104.66,88.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.67,
    cy: 88.15,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.9,
    cy: 87.44,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,86.59a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,108.38,86.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,85.87c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,109.61,85.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,85.16c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,110.85,85.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,84.45c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,112.09,84.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,83.73c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,113.33,83.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56,83c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,114.56,83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,82.3a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.8,82.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,81.59a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,117,81.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,81.15a.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28.57.57,0,0,1,.48,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,88.73a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,102.19,88.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,88a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,103.43,88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66,87.3c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,104.66,87.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,86.59a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,105.9,86.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,85.87a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,107.14,85.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,85.16c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,108.38,85.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,84.45c.14.07.14.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,109.61,84.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,83.73c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,110.85,83.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.85,
    cy: 83.15,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.33,82.3a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,113.33,82.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56,81.59a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,114.56,81.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,80.87a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.8,80.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,80.16a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,117,80.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.53,90.88a.49.49,0,0,1,.47,0c.13.07.13.19,0,.27a.52.52,0,0,1-.47,0C95.4,91.07,95.4,91,95.53,90.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.24,90.16c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.55.55,0,0,1,97.24,90.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.48,89.45c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,98.48,89.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.48,
    cy: 88.87,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,88a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,101,88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.19,87.3a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,102.19,87.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.19,
    cy: 86.73,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.66,85.87c.14.08.14.2,0,.28a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,104.66,85.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,85.16c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,105.9,85.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,84.45c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,107.14,84.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,83.73c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.57.57,0,0,1,108.38,83.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,83c.14.07.14.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,109.61,83Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.85,82.3a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,110.85,82.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.85,
    cy: 81.72,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.09,
    cy: 81.01,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.33,
    cy: 80.3,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,79.44a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,115.8,79.44Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,78.14c.13.07.13.19,0,.27a.49.49,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,115.76,78.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.76,
    cy: 77.56,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,76.71a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,118.24,76.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.24,
    cy: 76.13,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.48,
    cy: 75.42,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,74.56a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,122,74.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.19,73.85c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,123.19,73.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.05,77.42a.55.55,0,0,1,.47,0c.14.08.14.2,0,.28a.57.57,0,0,1-.48,0A.15.15,0,0,1,114.05,77.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,76.71a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,115.76,76.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,76a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,117,76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,75.28a.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0,.14.14,0,0,1,0-.27A.51.51,0,0,1,118.24,75.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,74.56a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,119.48,74.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.71,73.85c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,120.71,73.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,73.14c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,122,73.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81,76.71a.51.51,0,0,1,.48,0,.14.14,0,0,1,0,.27.51.51,0,0,1-.48,0A.14.14,0,0,1,112.81,76.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,76a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,114.53,76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.53,
    cy: 75.42,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,74.56a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,117,74.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,73.85c.13.08.13.2,0,.27a.51.51,0,0,1-.48,0c-.13-.07-.13-.19,0-.27A.51.51,0,0,1,118.24,73.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,73.14c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,119.48,73.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.48,
    cy: 72.56,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.58,76a.55.55,0,0,1,.47,0,.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0A.15.15,0,0,1,111.58,76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,75.28a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0c-.14-.07-.14-.2,0-.27A.49.49,0,0,1,113.29,75.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,74.56a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,114.53,74.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,73.85c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,115.76,73.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,73.14c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,117,73.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 72.56,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,75.28a.49.49,0,0,1,.47,0,.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0C110.21,75.48,110.21,75.36,110.34,75.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.05,74.56a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,112.05,74.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29,73.85c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.14-.07-.14-.19,0-.27A.49.49,0,0,1,113.29,73.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,73.14c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,114.53,73.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.29,72.42a.55.55,0,0,1,.47,0c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09,74.56a.49.49,0,0,1,.47,0c.13.07.14.2,0,.27a.49.49,0,0,1-.47,0A.14.14,0,0,1,109.09,74.56Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,73.84a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,79.72a.54.54,0,0,1-.48,0,.15.15,0,0,1,0-.28.55.55,0,0,1,.47,0c.14.08.14.2,0,.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,78.74a.51.51,0,0,1,.48,0c.13.07.13.19,0,.27a.51.51,0,0,1-.48,0A.14.14,0,0,1,116.57,78.74Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,78a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,118.29,78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.52,77.31a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,119.52,77.31Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,76.59a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,120.76,76.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.76,
    cy: 76.02,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,75.16a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,123.24,75.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,76.67a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,81.12,76.67Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,76.23a.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27.49.49,0,0,1,.47,0,.14.14,0,0,1,0,.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.59,75.52a.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28.55.55,0,0,1,.47,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,76a.14.14,0,0,1,0,.27.49.49,0,0,1-.47,0,.14.14,0,0,1,0-.27A.49.49,0,0,1,79.88,76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,75.24a.15.15,0,0,1,0,.28.57.57,0,0,1-.48,0,.15.15,0,0,1,0-.28A.57.57,0,0,1,81.12,75.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,74.53c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,82.35,74.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.59,73.82c.13.07.13.19,0,.27a.55.55,0,0,1-.47,0c-.13-.08-.13-.2,0-.27A.49.49,0,0,1,83.59,73.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.64,75.24a.15.15,0,0,1,0,.28.55.55,0,0,1-.47,0,.15.15,0,0,1,0-.28A.55.55,0,0,1,78.64,75.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,74.53c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27A.49.49,0,0,1,79.88,74.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,73.82c.13.07.13.19,0,.27a.57.57,0,0,1-.48,0c-.13-.08-.13-.2,0-.27A.51.51,0,0,1,81.12,73.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.35,73.1c.14.08.14.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.41,
    cy: 73.95,
    rx: 0.33,
    ry: 0.19,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,73.1c.13.08.13.2,0,.27a.49.49,0,0,1-.47,0c-.13-.07-.13-.19,0-.27Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.56,69h0l0,0-13.27-7.71a2.78,2.78,0,0,0-2.64.08L75.74,78.57l-.15.12a1.92,1.92,0,0,0,.29,3.13l0,0,0,0,13.27,7.69a2.73,2.73,0,0,0,2.59-.08l29.74-17.16.16-.1A1.89,1.89,0,0,0,121.56,69Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.59,69l0,0h0l0,0h0l0,0-13.28-7.71a2.84,2.84,0,0,0-2.7.08L75.7,78.52l-.15.11a1.89,1.89,0,0,0-.7,1.63,2,2,0,0,0,1,1.63h0l0,0,13.28,7.69a2.74,2.74,0,0,0,1.25.3,2.84,2.84,0,0,0,1.41-.38l29.74-17.16.16-.11a1.88,1.88,0,0,0,.83-1.64A1.94,1.94,0,0,0,121.59,69Zm-30,17a5.87,5.87,0,0,1,.09,2.5,1.58,1.58,0,0,1-1.14.94,2.75,2.75,0,0,1-1.34-.29L75.91,81.4l0,0h0a1.87,1.87,0,0,1-.87-1.1v0a1.75,1.75,0,0,1,.66-1.51l.13-.11,29.86-17.2a3,3,0,0,1,.52-.23,2.75,2.75,0,0,1,2.33.49l.25.19a.25.25,0,0,1,0,.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.18,87.15l-.44.26c-.13.07-.24,0-.24-.18h0a.58.58,0,0,1,.24-.45l.44-.25c.13-.08.24,0,.24.17h0A.55.55,0,0,1,95.18,87.15Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,86.79a.55.55,0,0,0-.24.44.36.36,0,0,0,0,.11l.06,0,.45-.26a.56.56,0,0,0,.23-.45.31.31,0,0,0,0-.1l-.07,0Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5,87.38v0a.37.37,0,0,1,0-.12.59.59,0,0,1,.25-.47h0l.45-.26.07,0h0v0a.5.5,0,0,1,0,.12.57.57,0,0,1-.26.48l-.44.26-.07,0Zm.25-.56a.49.49,0,0,0-.21.41.15.15,0,0,0,0,.07h0L95,87a.53.53,0,0,0,.22-.42.13.13,0,0,0,0-.06h0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.39,87.31h0c-.13.08-.24,0-.24-.17h0a.55.55,0,0,1,.24-.45h0c.13-.08.23,0,.23.18h0A.54.54,0,0,1,95.39,87.31Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.29,87.38a.12.12,0,0,1-.08,0,.25.25,0,0,1-.1-.22.62.62,0,0,1,.25-.49.21.21,0,0,1,.2,0,.27.27,0,0,1,.1.23.6.6,0,0,1-.25.48h0A.27.27,0,0,1,95.29,87.38Zm.19-.68-.07,0a.53.53,0,0,0-.22.42.16.16,0,0,0,.06.15.11.11,0,0,0,.11,0h0a.55.55,0,0,0,.21-.41c0-.08,0-.14-.06-.16Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.16,87.14a.57.57,0,0,1,.23-.45.16.16,0,0,1,.15,0h0l-.17-.12v0h0s-.08,0-.14,0A.58.58,0,0,0,95,87a.22.22,0,0,0,.07.18h0l.18.13A.21.21,0,0,1,95.16,87.14Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.19,87.35,95,87.22v0h0a.27.27,0,0,1-.08-.21.6.6,0,0,1,.26-.48.17.17,0,0,1,.18,0l0,0a0,0,0,0,1,0,0l.19.13,0,.07,0,0a.14.14,0,0,0-.11,0,.52.52,0,0,0-.21.41.17.17,0,0,0,0,.14Zm-.14-.21h0l.06,0v0a.59.59,0,0,1,.25-.48l0,0-.06,0h0l0,0s0,0-.1,0A.52.52,0,0,0,95,87c0,.06,0,.12,0,.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07,86.66a.54.54,0,0,1,.23-.45l1.34-.78a.17.17,0,0,1,.17,0l-.23-.16h0a.13.13,0,0,0-.17,0L96.05,86a.55.55,0,0,0-.24.45c0,.08,0,.13,0,.16h0l.26.18A.21.21,0,0,1,96.07,86.66Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,86.87l-.27-.19a.25.25,0,0,1-.07-.2A.61.61,0,0,1,96,86l1.35-.77a.19.19,0,0,1,.22,0l.24.17h0l0,.07h0a.09.09,0,0,0-.11,0l-1.35.77a.55.55,0,0,0-.21.42.18.18,0,0,0,0,.14Zm1.37-1.6a.11.11,0,0,0-.07,0l-1.34.77a.53.53,0,0,0-.22.42c0,.07,0,.11,0,.13h0l.13.09v0a.61.61,0,0,1,.25-.49l1.34-.77,0,0-.12-.09Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.64,86.06l-1.34.77c-.13.08-.23,0-.23-.17h0a.54.54,0,0,1,.23-.45l1.34-.78c.13-.07.24,0,.24.18h0A.58.58,0,0,1,97.64,86.06Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.21,86.9a.11.11,0,0,1-.08,0,.24.24,0,0,1-.1-.22.61.61,0,0,1,.25-.49l1.34-.77a.21.21,0,0,1,.2,0,.27.27,0,0,1,.1.23.59.59,0,0,1-.25.48l-1.35.78A.23.23,0,0,1,96.21,86.9Zm1.53-1.45-.07,0-1.35.77a.55.55,0,0,0-.21.42.16.16,0,0,0,.06.15.14.14,0,0,0,.11,0L97.62,86a.5.5,0,0,0,.22-.41q0-.12-.06-.15Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25,85.39a.54.54,0,0,1,.23-.45l1.34-.78a.17.17,0,0,1,.17,0L99.76,84h0a.13.13,0,0,0-.17,0l-1.34.78a.55.55,0,0,0-.24.45c0,.08,0,.13.05.16h0l.26.18A.21.21,0,0,1,98.25,85.39Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29,85.6,98,85.41a.25.25,0,0,1-.07-.2.62.62,0,0,1,.25-.49L99.55,84a.19.19,0,0,1,.22,0l.24.17h0l-.05.07h0a.09.09,0,0,0-.11,0L98.5,85a.55.55,0,0,0-.21.42.18.18,0,0,0,0,.14ZM99.66,84a.1.1,0,0,0-.07,0l-1.34.77a.53.53,0,0,0-.22.42c0,.07,0,.11,0,.13h0l.13.09v0a.61.61,0,0,1,.25-.49l1.34-.77,0,0L99.72,84Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,84.79l-1.34.77c-.13.08-.23,0-.23-.17h0a.54.54,0,0,1,.23-.45l1.34-.78c.13-.07.24,0,.24.18h0A.58.58,0,0,1,99.82,84.79Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.39,85.63a.11.11,0,0,1-.08,0,.24.24,0,0,1-.1-.22.61.61,0,0,1,.25-.49l1.34-.77a.21.21,0,0,1,.2,0,.27.27,0,0,1,.1.23.59.59,0,0,1-.25.48l-1.35.78A.23.23,0,0,1,98.39,85.63Zm1.53-1.45-.07,0L98.5,85a.55.55,0,0,0-.21.42.16.16,0,0,0,.06.15.14.14,0,0,0,.11,0l1.34-.78a.5.5,0,0,0,.22-.41q0-.12-.06-.15Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.72,78.82l29.85-17.2a2.78,2.78,0,0,1,2.64-.08l13.27,7.7a1.14,1.14,0,0,1,.06,1.94L91.8,88.33a2.71,2.71,0,0,1-2.59.08L75.94,80.72C75,80.16,75,79.27,75.72,78.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.45,88.5a2.85,2.85,0,0,1-1.24-.29L75.94,80.52a1.34,1.34,0,0,1-.75-1.06,1.08,1.08,0,0,1,.52-.92h0l29.85-17.2a2.8,2.8,0,0,1,2.68-.08L121.52,69a1.39,1.39,0,0,1,.6,1.16,1,1,0,0,1-.53.85L91.84,88.12A2.67,2.67,0,0,1,90.45,88.5ZM75.76,78.61a1,1,0,0,0-.48.84,1.26,1.26,0,0,0,.7,1l13.27,7.68a2.66,2.66,0,0,0,2.55-.08L121.54,70.9a1,1,0,0,0,.5-.79,1.3,1.3,0,0,0-.56-1.08l-13.27-7.7a2.7,2.7,0,0,0-2.6.08Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,70l-12.86-7.4a1.94,1.94,0,0,0-1.84.06l-27.9,16.1c-.47.32-.51.94.16,1.34l12.85,7.39a1.9,1.9,0,0,0,1.82-.06l27.81-16.07A.77.77,0,0,0,119.31,70Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,64.89a.42.42,0,0,1-.16,0h0a.13.13,0,0,1-.07-.12.16.16,0,0,1,.1-.14.41.41,0,0,1,.37,0h0a.14.14,0,0,1,.08.12.17.17,0,0,1-.11.14A.37.37,0,0,1,111.9,64.89Zm.06-.28a.33.33,0,0,0-.17,0,.1.1,0,0,0-.06.07.07.07,0,0,0,0,0h0a.33.33,0,0,0,.29,0,.1.1,0,0,0,.06-.07.09.09,0,0,0,0,0h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,66.85a.47.47,0,0,1-.17,0l-3-1.69a.15.15,0,0,1-.08-.12.18.18,0,0,1,.11-.15.4.4,0,0,1,.37,0l2.95,1.69a.14.14,0,0,1,.08.12.19.19,0,0,1-.1.14A.38.38,0,0,1,115.34,66.85Zm-2.88-2a.43.43,0,0,0-.17,0s-.06,0-.06.08a0,0,0,0,0,0,0l3,1.69a.3.3,0,0,0,.29,0s.06,0,.06-.07,0,0,0,0l-3-1.69A.24.24,0,0,0,112.46,64.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,83.61a.78.78,0,0,0-.83,0h0c-.8.39-1.49,2.76-1.89,4.49a1.72,1.72,0,0,1-.57,1h0l4.8-2.83A4.64,4.64,0,0,0,111.23,83.61Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55,82.31c-1.21-1.65-1.89-5-2.51-8.15-.69-3.5-1.73-8.29-4-9.54a1.91,1.91,0,0,0-2-.16l-8.83,5.09a2,2,0,0,1,1.87.21c1.09.6,1.86,2,2.48,3.69h0a38.23,38.23,0,0,1,1.48,5.82c.69,3.5,1.45,7.19,2.92,8.61a7.15,7.15,0,0,0,2.11,1.22s1.93,1.11,2.41-1c.4-1.73,1-4.17,2-4.57l2-1.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.22,70.59h0L93,70c-1.18-.64-1.55-.85-2.33-.55a2.07,2.07,0,0,1-1.58-.15L87,68l-8.87,5,2.12,1.23a2.07,2.07,0,0,0,1.58.15c.78-.3,1.15-.09,2.33.55l1.18.63h0l3.26,1.88c.4.23.79.48,1.17.74.65.44,2.2,1,3-2.86a17.11,17.11,0,0,1,1.45-4.82Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.11,69.71a2.25,2.25,0,0,0-1.51-.34,3,3,0,0,0-.36.18,4,4,0,0,0-1,1h0a16.91,16.91,0,0,0-1.45,4.81c-.37,1.88-.93,2.71-1.48,3h0l8.29-5C99,71.71,98.2,70.3,97.11,69.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,90.38a6.52,6.52,0,0,1-3.16-4.7c-.51-2.63-1.09-6.37-2.49-7.18a.78.78,0,0,0-.72-.07h0l-6.88,3.92-2.19,1.24h0a.78.78,0,0,1,.83,0c1.4.81,2,4.55,2.49,7.18a6.52,6.52,0,0,0,3.16,4.7l3.6,2.07,9-5.11Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.89,90.29a6.51,6.51,0,0,1-3.12-4.63l-.15-.8c-.48-2.54-1.08-5.7-2.38-6.45a.86.86,0,0,0-.82-.06l-6.81,3.87c-1.23-1.7-1.92-5.23-2.48-8.08s-1.61-8.27-4.06-9.6a2,2,0,0,0-2-.16l-8.7,5-.13.08h0a3.94,3.94,0,0,0-1,1L93,69.85c-1.16-.62-1.55-.83-2.36-.52a1.94,1.94,0,0,1-1.5-.15L87,67.93l-9.07,5.15,2.27,1.31a2.12,2.12,0,0,0,1.67.16c.72-.28,1.06-.09,2.2.52l1.23.66,3.29,1.88c.41.24.8.5,1.17.74a1.67,1.67,0,0,0,1,.33,1.3,1.3,0,0,0,.49-.1,1.72,1.72,0,0,0,.44-.3l7.87-4.73A38.54,38.54,0,0,1,101,79.29c.62,3.19,1.4,7.17,2.94,8.66a7,7,0,0,0,2.13,1.23,2.43,2.43,0,0,0,1.11.31,1.44,1.44,0,0,0,.57-.11l.25-.16,4.71-2.77c.32,1.12.56,2.4.78,3.55q.07.42.15.81a6.65,6.65,0,0,0,3.21,4.76l3.65,2.11,9.16-5.23ZM95.29,69.64a1.88,1.88,0,0,1,1.77.21c.92.5,1.68,1.62,2.4,3.51L92,77.83a6.9,6.9,0,0,0,.84-2.4,17.41,17.41,0,0,1,1.45-4.79l0-.07,0-.08h0A3.73,3.73,0,0,1,95.29,69.64Zm-5.42,8.55c-.37-.25-.76-.51-1.17-.75l-3.32-1.89h0l-1.21-.66c-1.16-.62-1.55-.83-2.36-.52a1.94,1.94,0,0,1-1.5-.15l-2-1.14L87,68.15l2.07,1.2a2.12,2.12,0,0,0,1.67.16c.72-.28,1.06-.09,2.2.52l1.12.6a18,18,0,0,0-1.39,4.7c-.31,1.61-.8,2.6-1.43,3l-.09.06h0A1.37,1.37,0,0,1,89.87,78.19Zm17.78,11a2,2,0,0,1-1.51-.19,7.26,7.26,0,0,1-2.08-1.2c-1.5-1.45-2.27-5.39-2.89-8.56a39.94,39.94,0,0,0-1.46-5.82h0l0-.07c-.75-2-1.55-3.21-2.53-3.74a2.66,2.66,0,0,0-1.2-.37l8.15-4.7a1.84,1.84,0,0,1,1.87.16c2.36,1.28,3.4,6.61,4,9.47s1.24,6.37,2.49,8.12l-2,1.12c-.92.38-1.52,2.41-2,4.42,0,.07,0,.15,0,.22s-.06.23-.07.25,0,.08,0,.12l0,.06a.54.54,0,0,1,0,.11.08.08,0,0,1,0,0,2.06,2.06,0,0,1-.11.18l-.1.12-.06.06,0,0A1.32,1.32,0,0,1,107.65,89.2Zm5-2.94-4.26,2.51h0l0-.07.06-.11,0-.07s0-.08,0-.13a.14.14,0,0,0,0-.06l.06-.22c.58-2.53,1.25-4.14,1.84-4.42l.06,0,0,0,0,0h0l.09,0h.15l.09,0h0l.1,0,.08,0h0l.11.07,0,0,.08.06s0,0,0,0l.06,0,0,.06,0,0,.07.08,0,0a.86.86,0,0,1,.07.1l0,0,.08.13h0A8.11,8.11,0,0,1,112.63,86.26Zm4.3,9.14a6.46,6.46,0,0,1-3.12-4.63l-.15-.8c-.22-1.18-.47-2.48-.8-3.62h0l0-.07a6.64,6.64,0,0,0-1.1-2.37h0l-.1-.11h0l-.1-.09h0l-.1-.08h0l-.12-.08-.15-.07h0l-.12,0h0l8.55-4.88a.69.69,0,0,1,.65.06c1.22.71,1.81,3.82,2.28,6.31q.07.42.15.81a6.69,6.69,0,0,0,3.22,4.76l3.44,2-8.76,5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-3",
    "data-name": "ACTIVE",
    d: "M93,70.52l1,.56a20.5,20.5,0,0,0-1.21,4.33c-.76,3.85-2.31,3.3-3,2.86-.38-.26-.77-.51-1.17-.74l-3.26-1.88h0L84.23,75c-1.18-.64-1.55-.85-2.33-.55a2.07,2.07,0,0,1-1.58-.15l-1.68-1L87,68.59l2.11,1.23a2.07,2.07,0,0,0,1.59.16C91.47,69.67,91.84,69.89,93,70.52Zm12.69-5.15a1.91,1.91,0,0,0-2-.17l-7.31,4.22a3,3,0,0,1,.66.28c1.1.59,1.87,2,2.49,3.69a40.73,40.73,0,0,1,1.48,5.82c.68,3.5,1.44,7.19,2.91,8.6A7.28,7.28,0,0,0,106.1,89s1.4.8,2.11-.28a19.16,19.16,0,0,1,1-3.23c.34-1,.77-1.86,1.31-2.08l1.46-.83c-1-1.76-1.66-4.8-2.23-7.72C109,71.4,108,66.61,105.71,65.37Zm8,25.41a6.48,6.48,0,0,0,3.17,4.7l3.59,2.08,8-4.54-2.94-1.69a6.5,6.5,0,0,1-3.17-4.7c-.51-2.63-1.08-6.38-2.48-7.18a.75.75,0,0,0-.73-.07h0l-6.88,3.92-.8.45C112.67,84.79,113.21,88.29,113.7,90.78Z",
    style: {
      fill: "#fff"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "121.22 91.88 118.43 93.49 118 93.23 120.79 91.62 121.22 91.88"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.03 93.73 117.19 94.21 116.76 93.96 117.6 93.47 118.03 93.73"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.99 92.34 117.97 94.66 117.54 94.41 121.56 92.09 121.99 92.34"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "120.36 94.17 118.72 95.11 118.29 94.86 119.92 93.92 120.36 94.17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.62,96a.5.5,0,0,1-.51,0c-.18-.1-.21-.21-.06-.3a.51.51,0,0,1,.52,0C120.74,95.76,120.78,95.86,120.62,96Zm-.51-.3c-.12.07-.09.16,0,.24a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.23A.42.42,0,0,0,120.11,95.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.13,95.65a.48.48,0,0,1-.51,0c-.17-.1-.21-.2-.05-.29a.5.5,0,0,1,.51,0C121.26,95.46,121.29,95.56,121.13,95.65Zm-.51-.29c-.12.07-.08.15.06.23a.39.39,0,0,0,.4,0c.12-.07.09-.15-.06-.23A.39.39,0,0,0,120.62,95.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.64,95.36a.5.5,0,0,1-.51,0c-.17-.1-.21-.21,0-.3a.5.5,0,0,1,.51,0C121.77,95.17,121.8,95.27,121.64,95.36Zm-.51-.3c-.12.07-.08.16.06.24a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.24A.41.41,0,0,0,121.13,95.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.16,95.06a.51.51,0,0,1-.52,0c-.17-.1-.2-.2,0-.29a.5.5,0,0,1,.51,0C122.28,94.87,122.31,95,122.16,95.06Zm-.51-.29c-.12.07-.09.15,0,.23a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.23A.39.39,0,0,0,121.65,94.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.67,94.77a.5.5,0,0,1-.51,0c-.18-.1-.21-.21-.06-.3a.5.5,0,0,1,.51,0C122.79,94.57,122.82,94.68,122.67,94.77Zm-.51-.3c-.12.07-.09.15,0,.23a.37.37,0,0,0,.4,0c.12-.06.09-.14,0-.23A.39.39,0,0,0,122.16,94.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.18,94.47a.5.5,0,0,1-.51,0c-.18-.1-.21-.21-.06-.3a.54.54,0,0,1,.52,0C123.3,94.28,123.33,94.38,123.18,94.47Zm-.51-.29c-.12.07-.09.15,0,.23a.39.39,0,0,0,.4,0c.12-.07.09-.15-.05-.23A.39.39,0,0,0,122.67,94.18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.92,94a.48.48,0,0,1-.51,0c-.18-.1-.21-.2,0-.29a.5.5,0,0,1,.51,0C124.05,93.85,124.08,94,123.92,94Zm-.51-.29c-.12.07-.08.15,0,.23a.41.41,0,0,0,.41,0c.12-.07.09-.15-.06-.23A.39.39,0,0,0,123.41,93.75Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.43,93.75a.5.5,0,0,1-.51,0c-.17-.1-.21-.21,0-.3a.5.5,0,0,1,.51,0C124.56,93.56,124.59,93.66,124.43,93.75Zm-.51-.3c-.12.07-.08.16.06.24a.39.39,0,0,0,.4,0c.12-.07.09-.15-.06-.24A.39.39,0,0,0,123.92,93.45Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.94,93.45a.5.5,0,0,1-.51,0c-.17-.1-.21-.2-.05-.29a.5.5,0,0,1,.51,0C125.07,93.26,125.1,93.36,124.94,93.45Zm-.51-.29c-.12.07-.08.15.06.23a.39.39,0,0,0,.4,0c.12-.07.09-.15,0-.23A.41.41,0,0,0,124.43,93.16Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.54,93.1a0,0,0,0,1-.05,0l-.47-.27,0,0a0,0,0,0,1,0,0h0a0,0,0,0,1,0,0l.07,0a0,0,0,0,1,0,0l.49.29s0,0,0,0Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "84.65 71.09 80.64 73.41 80.2 73.16 84.22 70.84 84.65 71.09"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.18 70.21 85.05 70.86 84.61 70.61 85.74 69.96 86.18 70.21"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "83.02 72.92 81.39 73.86 80.95 73.61 82.58 72.67 83.02 72.92"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.94 70.65 83.42 72.69 82.99 72.44 86.51 70.4 86.94 70.65"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.15 72.05 86.36 73.66 85.92 73.41 88.71 71.8 89.15 72.05"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.96 73.9 85.12 74.39 84.68 74.14 85.52 73.65 85.96 73.9"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "89.92 72.52 85.9 74.83 85.46 74.58 89.48 72.26 89.92 72.52"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.34 75.26 87.5 75.74 87.06 75.49 87.9 75.01 88.34 75.26"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.5 74.9 88.28 76.19 87.84 75.94 90.07 74.65 90.5 74.9"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.28 74.34 86.65 75.29 86.21 75.03 87.84 74.09 88.28 74.34"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "92.2 72.08 88.68 74.11 88.25 73.86 91.77 71.83 92.2 72.08"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.54 73.02 100.39 72.45 106.92 68.74 107.07 69.3 100.54 73.02"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.91 74.05 100.76 73.49 102.69 72.39 102.83 72.95 100.91 74.05"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.47 72.59 103.33 72.03 107.21 69.85 107.35 70.41 103.47 72.59"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.17 75.14 101.02 74.58 104.9 72.4 105.05 72.96 101.17 75.14"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.45 76.24 101.31 75.68 102.4 75.06 102.55 75.61 101.45 76.24"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.02 75.31 102.88 74.74 106.48 72.75 106.62 73.31 103.02 75.31"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.28 80.51 102.13 79.92 108.38 76.36 108.53 76.95 102.28 80.51"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "102.45 81.6 102.31 81.01 104.16 79.96 104.3 80.55 102.45 81.6"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "104.91 80.2 104.77 79.61 108.48 77.53 108.62 78.12 104.91 80.2"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "113.3 84.89 113.14 84.35 115.03 83.27 115.2 83.8 113.3 84.89"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.83 83.45 115.66 82.91 119.48 80.76 119.65 81.3 115.83 83.45"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "113.65 85.93 113.48 85.39 117.3 83.25 117.47 83.79 113.65 85.93"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-4",
    "data-name": "ACTIVE",
    d: "M87.44,83.17,83,80.61c-.78-.45-.68-1.24.22-1.76h0a3.4,3.4,0,0,1,3-.12l4.47,2.56c.78.45.68,1.23-.22,1.76h0A3.4,3.4,0,0,1,87.44,83.17Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.76,83.51a2.72,2.72,0,0,1-1.35-.31l-4.47-2.56a1,1,0,0,1-.56-.82,1.32,1.32,0,0,1,.78-1.06,3.46,3.46,0,0,1,3.11-.12l4.47,2.56a1,1,0,0,1,.56.82,1.31,1.31,0,0,1-.78,1A3.62,3.62,0,0,1,88.76,83.51Zm-1.29-.43a3.31,3.31,0,0,0,3-.13,1.19,1.19,0,0,0,.72-.93.87.87,0,0,0-.5-.71l-4.46-2.56a3.31,3.31,0,0,0-3,.13,1.19,1.19,0,0,0-.72.94.84.84,0,0,0,.5.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.38,79.84c.29.17.3.4,0,.56a1,1,0,0,1-1,0l-.35-.21-.52.3a.12.12,0,0,1-.14,0h0s0,0,0-.08l1.41-.81a.12.12,0,0,1,.14,0Zm-.81.47a.7.7,0,0,0,.66,0c.19-.12.2-.27,0-.38l-.35-.2-.66.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,81s0-.06,0-.07l2.05-.45a.19.19,0,0,1,.13,0l.06,0s0,0,0,.07l-.78,1.19s-.08,0-.14,0h0s0,0,0-.08l.31-.47-.66-.38-.82.17a.19.19,0,0,1-.13,0Zm2.05-.38-.86.19.53.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.09,82s0-.06,0-.07l.55-.11L88.2,81a.09.09,0,0,1,.13,0h0s0,0,0,.08l-.45.75,1.3-.26a.19.19,0,0,1,.13,0h0c.06,0,0,.06,0,.08l-2.11.41a.15.15,0,0,1-.13,0Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.85.29,56.87,28l48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L56.87,28V83.4l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFgLight3);
export default __webpack_public_path__ + "static/media/ICON_fg_light_3.2f9eefd73fd38ddd70c4576d883ba17f.svg";
export { ForwardRef as ReactComponent };